import axios, {AxiosError, AxiosResponse} from "axios";
import $ from "jquery";

// import {CompanyInformationForCookie, ExportedGet, ExportedGetRequest, ExportedGetResponse, ExportedPost, ExportedPostRequest, ExportedPostResponse} from "@/ExportedTypes/ExportedTypes";
import { CompanyInformationForCookie } from "@/app/pages/businessDirectory/IBusinessDirectory";

const isUndefined = <T>(t: T | undefined): t is undefined =>
  typeof t === "undefined";

const isUndefinedOrNull = <T>(t: T | null | undefined): t is (null | undefined) => isUndefined(t) || t === null;

const isNotUndefined = <T>(t: T | undefined): t is T => !isUndefined(t);

const isNotUndefinedOrNull = <T>(t: T | null | undefined): t is T =>
  !isUndefined(t) && t !== null;

export interface ExportedGet<R, S> {
    exportedGetRequest?: R;
    exportedGetResponse?: S;
}

export interface ExportedGetRequest<E> {
}

export interface ExportedGetResponse<E> {
}

export interface ExportedPost<R, S> {
    exportedPostRequest?: R;
    exportedPostResponse?: S;
}

export interface ExportedPostRequest<E> {
}

export interface ExportedPostResponse<E> {
}


enum TrustArcGroupId {
  /**
   * StrictlyNecessaryCookies
   */
  trustArcGroupOne = 1,

  /**
   * FunctionalCookies
   */
  trustArcGroupTwo = 2,

  /**
   * AdvertisingCookies
   */
  trustArcGroupThree = 3,
}

// // Canada/United States-only regular expression
const canadaUnitedStatesPhoneNumberRegularExpression = /^\(?(\d{3})\)?[ .-]?(\d{3})[ .-]?(\d{4})$/;

const canadaIsoCode = "CA";
const irelandIsoCode = "IE";
const unitedKingdomIsoCode = "UK";
const unitedStatesIsoCode = "US";

const companyInfoCookieName = "companyInfo";
const dataCnCookieName = "cn";
const dataEmCookieName = "em";
const dataFnCookieName = "fn";
const dataTnCookieName = "tn";
const gclidCookieName = "gclid";
const gpcpCookieName = "gpcp";
const h9mcCookieName = "h9mc";
const hidCookieName = "HID";
const languagePreferenceCookieName = "language_preference";
const resourceAccessCookieName = "ResourceAccess";
const sitePreferenceCookieName = "site_preference";
const wAddressCookieName = "w_addressAddress";
const wBusPhoneCookieName = "w_busPhone";
const wCompanyNameCookieName = "w_companyName";
const wEmailAddressCookieName = "w_emailAddress";
const wFirstNameCookieName = "w_firstName";
const wLastNameCookieName = "w_lastName";
const wTitleCookieName = "w_title";
const wZipPostalCookieName = "w_zipPostal";

const body = "body";

const overlayClassName = "overlay";

interface RuntimeEnvironmentContainer {
    "runtimeEnvironment": string | undefined;
}

const runtimeEnvironmentContainer: RuntimeEnvironmentContainer = {
    "runtimeEnvironment": void 0
};

const setRuntimeEnvironment: (runtimeEnvironment: string) => void = (runtimeEnvironment: string) => {
    runtimeEnvironmentContainer.runtimeEnvironment = runtimeEnvironment;
};

const getRuntimeEnvironment = (): string | undefined => runtimeEnvironmentContainer.runtimeEnvironment;

const emailAddressRegularExpression = /^(([^\s"(),.:;<>@[\\\]]+(\.[^\s"(),.:;<>@[\\\]]+)*)|(".+"))@((\[(?:\d{1,3}\.){3}\d{1,3}])|(([\dA-Za-z-]+\.)+[A-Za-z]{2,}))$/;

const functionalCookies: Record<string, undefined> = {
  [languagePreferenceCookieName]: void 0,
};

const marketingCookies: Record<string, undefined> = {
  [dataCnCookieName]: void 0,
  [dataEmCookieName]: void 0,
  [dataFnCookieName]: void 0,
  [dataTnCookieName]: void 0,
  [gclidCookieName]: void 0,
  [h9mcCookieName]: void 0,
  [wAddressCookieName]: void 0,
  [wBusPhoneCookieName]: void 0,
  [wCompanyNameCookieName]: void 0,
  [wEmailAddressCookieName]: void 0,
  [wFirstNameCookieName]: void 0,
  [wLastNameCookieName]: void 0,
  [wTitleCookieName]: void 0,
  [wZipPostalCookieName]: void 0,
};

const strictlyNecessaryCookies: Record<string, undefined> = {
  [companyInfoCookieName]: void 0,
  [gpcpCookieName]: void 0,
  [hidCookieName]: void 0,
  [sitePreferenceCookieName]: void 0,
};

const extIcon = "ext-icon";

enum LogSeverity {
  DEBUG,
  ERROR,
  INFO,
  WARN,
}

const dnbComLog = (logSeverity: LogSeverity, ...data: any[]): void => {

  if (logSeverity === LogSeverity.DEBUG) {
    console.debug(data);
    return;
  } else if (logSeverity === LogSeverity.INFO) {
    console.info(data);
    return;
  } else if (logSeverity === LogSeverity.WARN) {
    console.warn(data);
    return;
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  } else if (logSeverity === LogSeverity.ERROR) {
    console.error(data);
    return;
  }
  console.log(data);

  // TODO Restore logging to New Relic
};

type ConsolidatedHeaderObjectCallback = ($element: JQuery) => void;

interface ConsolidatedHeaderObject {
  $consolidatedHeaderWrapper: JQuery | undefined;
  consolidatedHeaderWrapperCallbackArray: ConsolidatedHeaderObjectCallback[];
  headerPosition: boolean;
  onHeaderHeightChange: () => void;
  registerConsolidatedHeaderWrapperCallback: (
    consolidatedHeaderObjectCallback: ConsolidatedHeaderObjectCallback
  ) => void;
  setConsolidatedHeaderWrapper: ($element: JQuery) => void;
  showHeader: boolean;
}

const consolidatedHeaderObject: ConsolidatedHeaderObject = {
  $consolidatedHeaderWrapper: void 0,
  consolidatedHeaderWrapperCallbackArray: [],
  headerPosition: false,
  onHeaderHeightChange: () =>
    dnbComLog(LogSeverity.ERROR, "onHeaderHeightChange has not been set"),
  registerConsolidatedHeaderWrapperCallback: function (
    consolidatedHeaderObjectCallback
  ) {
    if (isUndefined(this.$consolidatedHeaderWrapper)) {
      this.consolidatedHeaderWrapperCallbackArray.push(
        consolidatedHeaderObjectCallback
      );
    } else {
      consolidatedHeaderObjectCallback(this.$consolidatedHeaderWrapper);
    }
  },
  setConsolidatedHeaderWrapper: function ($element) {
    this.$consolidatedHeaderWrapper = $element;

    for (const value of this.consolidatedHeaderWrapperCallbackArray) {
      value($element);
    }
  },
  showHeader: false,
};

enum EvenHeightsMode {
    Original,
    VersionTwo,
    Unfiltered,
}

const evenHeightsCore =
    (evenHeightsMode: EvenHeightsMode): ((root: HTMLElement | JQuery, selector: string) => void) =>
        (root: HTMLElement | JQuery, selector: string) => {
            const $root = root instanceof HTMLElement ? $(root) : root;

            // Build array of elements to target
            const $elements = $root.find(selector);

            let elementsToMeasure: HTMLElement[];

            if (evenHeightsMode === EvenHeightsMode.VersionTwo) {
                // Filter out elements with certain parents
                elementsToMeasure = $elements.toArray().filter((ht) => $(ht).parents(".large_cards, .suggested_articles, .suggested_related_products, .other, .videoWrapper").length === 0);
            } else if (evenHeightsMode === EvenHeightsMode.Original) {
                elementsToMeasure = $root
                    .find(`.card ${selector}`)
                    .toArray()
                    .filter((ht) => $(ht).parents(".large_cards, .suggested_articles, .suggested_related_products, .other").length === 0);
            } else {
                elementsToMeasure = $root.find(selector).toArray();
            }

            if (elementsToMeasure.length > 1) {
                // Measure all filtered elements and determine maximum height
                const heightArray = elementsToMeasure.map((ht) => $(ht).height());

                const heightArrayFiltered: number[] = [];

                for (const va of heightArray) {
                    if (isNotUndefined(va)) {
                        heightArrayFiltered.push(va);
                    }
                }

                const maxHeight = window.Math.max(...heightArrayFiltered);

                if (evenHeightsMode === EvenHeightsMode.VersionTwo) {
                    // Apply inline style to all filtered elements, using min-height to prevent content overflows
                    // Added 1px to solve for IE issue
                    for (const ht of elementsToMeasure) {
                        $(ht).css("min-height", `${maxHeight + 1}px`);
                    }
                } else {
                    // Added 1px to solve for IE issue
                    $elements.height(maxHeight + 1);
                }
            }
        };

// Even-heights.js v1.8
const evenHeights = evenHeightsCore(EvenHeightsMode.Original);

// New even-heights script v2.0
// Set 'root' argument to limit scope of card selection
// Set 'selector' to designate the child element to apply height property. this argument can take multiple selectors such as '.card .title' or '.content_card .description'.
const evenHeightsV2 = evenHeightsCore(EvenHeightsMode.VersionTwo);

// Unfiltered even-heights script to apply even heights for any selector.
const evenHeightsUnfiltered = evenHeightsCore(EvenHeightsMode.Unfiltered);

const currentTimestamp = (): number => window.Date.now();

const getWindowExponea = (): any => {
    const windowExponea: any = window["exponea"];

    if (typeof windowExponea !== "object" || windowExponea === null) {
        dnbComLog(LogSeverity.ERROR, "windowExponea is not an expected value");
    }

    return windowExponea;
};

const trackBloomreachCartEvents = (productId: string[] | number | string | undefined, priceId: string[] | number | string | null | undefined, renewalType: string[] | number | string | null | undefined, price: string[] | number | string | null | undefined): void => {
    try {
        const windowExponea = getWindowExponea();

        windowExponea.track("add_to_cart", {
            "domain": window.location.hostname,
            "location": window.location.href,
            "normalPrice": price,
            "price_id": priceId,
            "product_id": productId,
            "quantity": 1,
            "renewal_type": renewalType,
        });
    } catch (er) {
        dnbComLog(LogSeverity.ERROR, er);
    }
};

const getPrivacyManagerAPI = (): any => {
  try {
    const privacyManagerAPI: any = window["PrivacyManagerAPI"];

  if (typeof privacyManagerAPI !== "object" || privacyManagerAPI === null) { 
    dnbComLog(LogSeverity.ERROR, "privacyManagerAPI is not an expected value");
  }
  return privacyManagerAPI;
  } catch{
    dnbComLog(LogSeverity.ERROR, "privacyManagerAPI is not an expected value")
  }
  // return {"version":"1.7","debug":false}
};

const getWindowS = (): any => {
    const windowS: any = window["s"] || {};

    if (typeof windowS !== "object" || windowS === null) {
        dnbComLog(LogSeverity.ERROR, "windowS is not an expected value");
    }
  
    return windowS;
};
  
const getWindowDataLayer = (): any => {
    const windowDataLayer: any = window["dataLayer"];

    if (typeof windowDataLayer !== "object" || windowDataLayer === null) {
        dnbComLog(LogSeverity.ERROR, "windowDataLayer is not an expected value");
    }

    return windowDataLayer;
};

const trustArcGroupIsActive = (trustArcGroupId: TrustArcGroupId): boolean => {
  const privacyManagerAPI = getPrivacyManagerAPI();

  if (isNotUndefinedOrNull(privacyManagerAPI)) {
      // Fetch consent level that the user chose to a granular level.
      const getGDPRConsentDecision = privacyManagerAPI.callApi("getGDPRConsentDecision", window.location.hostname);

      const trustArcActiveGroupsFiltered: any[] = getGDPRConsentDecision.consentDecision;

      return trustArcActiveGroupsFiltered.includes(trustArcGroupId);
  }

  return false;
};

const trackCartEventsCore = (productId: string[] | number | string | undefined): void => {
    try {
        const windowS = getWindowS();

        windowS.events = "scAdd,event63";
        windowS.linkTrackVars = "events,products";
        // TODO ???
        // Z s.products = category:productId;Quantity;dollarAmount
        windowS.products = `;${productId};1;`;
        windowS.linkTrackEvents = "scAdd,event63";

        windowS.tl(true, "o", "AddToCart");
    } catch (er) {
        dnbComLog(LogSeverity.ERROR, er);
    }
};

const trackCartEvents = (htmlElement: HTMLElement | null | undefined): void => {
    if (isNotUndefined(htmlElement) && htmlElement !== null) {
        const $parent = $(htmlElement).parent();

        const price = $parent.find('input[name="price"]').val();
        const priceId = $parent.find('input[name="priceId"]').val();
        const productId = $parent.find('input[name="productId"]').val();
        const subscriptionLabel = $parent.find('input[name="subscription_label"]').val();

        const productIdToUse = isNotUndefined(productId) && productId !== "" ? productId : $parent.find('input[name="sku"]').val();

        trackCartEventsCore(productIdToUse);
        trackBloomreachCartEvents(productIdToUse, priceId, subscriptionLabel, price);
    }
};

const trackBloomreachIdentifyEvents = (emailId: string): void => {
    try {
        const windowExponea = getWindowExponea();

        windowExponea.identify({
            "email_id": emailId,
        });
    } catch (er) {
        dnbComLog(LogSeverity.ERROR, er);
    }
};

const trackBloomreachConsentEvents = (action: string, category: string | null, valid_until: string | null, message: string | null, language: string | null, placement: string | null): void => {
    try {
        const windowExponea = getWindowExponea();

        windowExponea.track("consent", {
            "action": action,
            "category": category,
            "domain": window.location.host,
            "language": language,
            "location": window.location.href,
            "message": message,
            "placement": placement,
            "timestamp": currentTimestamp(),
            "valid_until": valid_until,
        });
    } catch (er) {
        dnbComLog(LogSeverity.ERROR, er);
    }
};

const trackBloomreachPurchaseEvents = (purchase_id: string, purchase_status: string, purchase_source_type: string, purchase_source_name: string, locationParameter: string, domain: string, language: string, product_ids: string, total_price: number, total_price_without_tax: number, total_price_local_currency: string | null, timestamp: string): void => {
    try {
        const windowExponea = getWindowExponea();

        windowExponea.track("purchase", {
            "domain": domain,
            "language": language,
            "location": locationParameter,
            "product_ids": product_ids,
            "purchase_id": purchase_id,
            "purchase_source_name": purchase_source_name,
            "purchase_source_type": purchase_source_type,
            "purchase_status": purchase_status,
            "timestamp": timestamp,
            "total_price": total_price,
            "total_price_local_currency": total_price_local_currency,
            "total_price_without_tax": total_price_without_tax,
            "total_quantity": 1,
        });
    } catch (er) {
        dnbComLog(LogSeverity.ERROR, er);
    }
};

const trackBloomreachPurchaseItemEvents = (purchase_id: string, product_group: string | null, product_category: string | null, product_name: string | null, renewal_type: string | null, product_id: string | null, price: number, price_id: string | null, total_price_without_tax: number, total_price_local_currency: string | null, timestamp: string): void => {
    try {
        const windowExponea = getWindowExponea();

        windowExponea.track("purchase_item", {
            "normalPrice": price,
            "price_id": price_id,
            "product_category": product_category,
            "product_group": product_group,
            "product_id": product_id,
            "product_name": product_name,
            "purchase_id": purchase_id,
            "quantity": 1,
            "renewal_type": renewal_type,
            "timestamp": timestamp,
            "total_price_local_currency": total_price_local_currency,
            "total_price_without_tax": total_price_without_tax,
        });
    } catch (er) {
        dnbComLog(LogSeverity.ERROR, er);
    }
};

const trackBloomreachViewEvents = (productId: string[] | number | string | undefined): void => {
    try {
        const windowExponea = getWindowExponea();

        windowExponea.track("view_item", {
            "location": window.location.href,
            "product_id": productId,
        });
    } catch (er) {
        dnbComLog(LogSeverity.ERROR, er);
    }
};

const clearVars = (): void => {
  try {
    const windowS = getWindowS();

    for (let index = 0; index < 250; index += 1) {
      windowS[`prop${index}`] = "";
      windowS[`eVar${index}`] = "";
    }

    const array = ["events"];

    for (const st of array) {
      windowS[st] = "";
    }
  } catch (er) {
    dnbComLog(LogSeverity.ERROR, er);
  }
};

const trackAdobeEvents = (
  data: string[] | number | string | null | undefined,
  linkTrackVars: string,
  linkTrackEvents: string | null,
  eVarName: string | null,
  message?: string
): void => {
  try {
    const windowS = getWindowS();
    let adobeMessage = message;

    windowS.linkTrackVars = linkTrackVars;
    if (isNotUndefinedOrNull(linkTrackEvents)) {
      windowS.linkTrackEvents = windowS.events = linkTrackEvents;
    }

    if (isNotUndefinedOrNull(data) && isNotUndefinedOrNull(eVarName)) {
      windowS[eVarName] = data;
      adobeMessage = `${data} Clicked`;
    }
    windowS.tl(this, "o", adobeMessage);
    clearVars();
  } catch (er) {
    dnbComLog(LogSeverity.ERROR, er);
  }
};

const trackGTMEvents = (events: Record<string, any> | null): void => {
    try {
        const _dataLayer = getWindowDataLayer();

        if (isNotUndefined(_dataLayer) && _dataLayer !== null) {
            _dataLayer.push(events);
        }
    } catch (er) {
        dnbComLog(LogSeverity.ERROR, er);
    }
};

const trackGTMSearchSubmitEvents = (searchTerm: number | string | undefined, eventName: string = "searchSubmit",  queryKey: string="searchQuery"): void => {
    try {
        const _dataLayer = getWindowDataLayer();

        if (isNotUndefined(_dataLayer) && _dataLayer !== null) {
            _dataLayer.push({
                "event": eventName,
                [queryKey]: searchTerm
            });
        }
    } catch (er) {
        dnbComLog(LogSeverity.ERROR, er);
    }
};

const trackCompanyProfileGalleryClickEvents = (eventType: string | null | undefined): void => {
    try {
        if (isNotUndefinedOrNull(eventType)) {
            if (eventType === "galleryOpen") {
                trackAdobeEvents(null,  "events", "event9", null, "Gallery Opened");
            } else if (eventType === "photoView") {
              
                trackAdobeEvents(null,  "events", "event10", null, "Photo Viewed");
            } else if (eventType === "videoView") {
        
                trackAdobeEvents(null,  "events", "event10", null, "Video Viewed");
            }
        }
    } catch (er) {
        dnbComLog(LogSeverity.ERROR, er);
    }
};

const trackDataMaskIconClickEvents = (
  fieldName: string | null | undefined
): void => {
  trackAdobeEvents(fieldName, "events,eVar135", "event102", "eVar135");
};

const videoTracking = (fieldName: string, eventName: "event7" | "event8"): void => {
    trackAdobeEvents(fieldName,  "events,eVar144", eventName, "eVar144");
};

const trackAssociateDunsCompanySearchEvent = (fieldName: string | null | undefined): void => {
    trackAdobeEvents(fieldName,  "events", "event96", "eVar135");
};

const trackAssociateDunsContinueToCpEvents = (fieldName: string | null | undefined): void => {
    trackAdobeEvents(fieldName,  "events", "event97", "eVar135");
};

const trackPostCardClickEvents = (fieldName: string | null | undefined): void => {

    trackAdobeEvents(fieldName,  "eVar137", null, "eVar137");
};

const trackSearchType = (activeTab: string[] | number | string | undefined): void => {
   
    trackAdobeEvents(activeTab,  "eVar105", null, "eVar105");
};

const trackAdobeUTMEvents = (utm:  string | null | undefined, eVar: string): void => {
    try {
        if (isNotUndefinedOrNull(utm)) {
            const windowS = getWindowS();
            windowS.linkTrackVars = eVar;
            windowS[eVar] = utm;
            windowS.t(this, "o", `${utm}`);
        }
    } catch (er) {
        dnbComLog(LogSeverity.ERROR, er);
    }
};

const trackUTMCodesOnGADFlow = (utm_medium: string | null | undefined,
    utm_source: string | null | undefined,
    utm_campaign: string | null | undefined,
    utm_term: string | null | undefined,
    utm_content: string | null | undefined,): void => {
    try {

        if (isNotUndefined(utm_medium) && utm_medium !== null) {
            trackAdobeUTMEvents(utm_medium,  "eVar87");
        }

        if (isNotUndefined(utm_source) && utm_source !== null) {
            trackAdobeUTMEvents(utm_source,  "eVar75");
        }

        if (isNotUndefined(utm_campaign) && utm_campaign !== null) {
            trackAdobeUTMEvents(utm_campaign,  "eVar23");
        }

        if (isNotUndefined(utm_term) && utm_term !== null) {
            trackAdobeUTMEvents(utm_term,  "eVar90");
        }

        if (isNotUndefined(utm_content) && utm_content !== null) {
            trackAdobeUTMEvents(utm_content,  "eVar91");
        }
        clearVars();
    } catch (er) {
        dnbComLog(LogSeverity.ERROR, er);
    }
};

// TODO
// This kind of duplication constitutes unacceptable technical debt
const trackPartnerExchangeExitEvents = (partnerItemTitle: string, linkText: string): void => {
    try {
        if (isNotUndefinedOrNull(partnerItemTitle) && isNotUndefinedOrNull(linkText)) {
            const windowS = getWindowS();

            windowS.linkTrackVars = "eVar139";
            windowS.eVar139 = (partnerItemTitle);
            windowS.tl(this, "o", `${linkText} Clicked`);

            clearVars();
        }
    } catch (er) {
        dnbComLog(LogSeverity.ERROR, er);
    }
};
const analyticsEvent = (eventType: string): void => trackPostCardClickEvents(`${eventType}`);

const trackNullSearchResults = (): void => {
  trackAdobeEvents(null, "events", "event50", null, "No Search Results");
};

const trackRefineSearchClickEvents = (
  refineSearchOption: string[] | number | string | undefined
): void => {
  try {
    const windowS = getWindowS();

    windowS.eVar106 = `Refine Search - ${refineSearchOption}`;
    windowS.linkTrackVars = "eVar106";

    windowS.tl(true, "o", `Refine Search - ${refineSearchOption}`);

    clearVars();
  } catch (er) {
    dnbComLog(LogSeverity.ERROR, er);
  }
};

const trackSearchEvents = (tabName: string | undefined, searchTerm: number | string | undefined): void => {
    try {
        const windowS = getWindowS();

        windowS.linkTrackVars = "events,eVar11,prop11,prop27";
        windowS.linkTrackEvents = windowS.events = "event29";

        if (tabName === "Contact Directory") {
            windowS.prop27 = searchTerm;
        } else {
            windowS.eVar11 = searchTerm;
            windowS.prop11 = searchTerm;
        }

        windowS.tl(this, "o", "search click");

        clearVars();
    } catch (er) {
        dnbComLog(LogSeverity.ERROR, er);
    }

    trackGTMSearchSubmitEvents(searchTerm);
};

type RunAfterScriptMarketoLoadCallback = (mktoFormsTwo: any) => void;

interface LazyLoadScriptMarketoObject {
    "addRunAfterScriptLoadCallback": (runAfterScriptLoadCallback: RunAfterScriptMarketoLoadCallback) => void;
    "runAfterScriptLoadCallbackArray": RunAfterScriptMarketoLoadCallback[];
    "scriptLoaded": boolean;
    "setScriptLoaded": () => void;
    "windowMktoFormsTwo": any;
}

const lazyLoadScriptMarketoInternal = (scriptSource: string, lazyLoadScriptObjectPropertyName: string): LazyLoadScriptMarketoObject => {
    // @ts-expect-error Ignore
    if (isUndefined(window[lazyLoadScriptObjectPropertyName])) {
        const lazyLoadScriptObject: LazyLoadScriptMarketoObject = {
            "addRunAfterScriptLoadCallback": (runAfterScriptLoadCallback: (windowMktoFormsTwo: any) => void) => {
                if (lazyLoadScriptObject.scriptLoaded) {
                    runAfterScriptLoadCallback(lazyLoadScriptObject.windowMktoFormsTwo);
                } else {
                    lazyLoadScriptObject.runAfterScriptLoadCallbackArray.push(runAfterScriptLoadCallback);
                }
            },
            "runAfterScriptLoadCallbackArray": [],
            "scriptLoaded": false,
            "setScriptLoaded": () => {
                lazyLoadScriptObject.scriptLoaded = true;
                lazyLoadScriptObject.windowMktoFormsTwo = window["MktoForms2"];

                for (const runAfterScriptLoadCallbackArrayElement of lazyLoadScriptObject.runAfterScriptLoadCallbackArray) {
                    try {
                        runAfterScriptLoadCallbackArrayElement(lazyLoadScriptObject.windowMktoFormsTwo);
                    } catch (er) {
                        dnbComLog(LogSeverity.ERROR, er);
                    }
                }
            },
            "windowMktoFormsTwo": void 0,
        };

        const $script = $("<script></script>")
            .attr("src", scriptSource)
            .attr("async", "async")
            .on("load", () => lazyLoadScriptObject.setScriptLoaded());

        // Z onload does not fire if the script is appended using jQuery
        $("head")[0]!.append($script[0]!);

        // @ts-expect-error Ignore
        window[lazyLoadScriptObjectPropertyName] = lazyLoadScriptObject;

        return lazyLoadScriptObject;
    } else {
        // @ts-expect-error Ignore
        return window[lazyLoadScriptObjectPropertyName];
    }
};

// /**
//  * @param marketoUrl - Should be of the format "//app-sj31.marketo.com" (this is the Ireland/UK URL)
//  */
const lazyLoadScriptMarketo = (marketoUrl: string): LazyLoadScriptMarketoObject => {
    const urlToUse = marketoUrl.length > 0 ? marketoUrl : "//app-sj28.marketo.com";

    const formsTwoMinJsUrl = `${urlToUse}/js/forms2/js/forms2.min.js`;

    return lazyLoadScriptMarketoInternal(formsTwoMinJsUrl, "dnbMarketoLazyLoadScriptObject");
};

type MarketoFormLoadCallback = (marketoForm: any) => void;

interface MarketoFormHolder {
    "marketoForm": any;
}

interface MarketoFormWrapper {
    "addMarketoFormLoadCallback": (ma: MarketoFormLoadCallback) => void;
    "marketoFormHolder": MarketoFormHolder | undefined;
    "queuedMarketoFormLoadCallbacks": MarketoFormLoadCallback[];
    "runMarketoFormLoadCallbacks": (marketoForm: any) => void;
}

const getMarketoFormWrapper = (): MarketoFormWrapper => {
    const marketoFormWrapper: MarketoFormWrapper = {
        "addMarketoFormLoadCallback": (ma) => {
            const {
                marketoFormHolder,
                queuedMarketoFormLoadCallbacks
            } = marketoFormWrapper;

            if (isNotUndefined(marketoFormHolder)) {
                ma(marketoFormHolder.marketoForm);
            } else {
                queuedMarketoFormLoadCallbacks.push(ma);
            }
        },
        "marketoFormHolder": void 0,
        "queuedMarketoFormLoadCallbacks": [],
        "runMarketoFormLoadCallbacks": (marketoForm) => {
            marketoFormWrapper.marketoFormHolder =
                {
                    "marketoForm": marketoForm
                };

            for (const queuedMarketoFormLoadCallback of marketoFormWrapper.queuedMarketoFormLoadCallbacks) {
                try {
                    queuedMarketoFormLoadCallback(marketoForm);
                } catch (er) {
                    dnbComLog(LogSeverity.ERROR, er);
                }
            }

            marketoFormWrapper.queuedMarketoFormLoadCallbacks = [];
        },
    };

    return marketoFormWrapper;
};

const dnbGetCookie = (cookieName: string): string | undefined => {
  const cookieSplit = window.document.cookie.split(";");

  for (const st of cookieSplit) {
      const cookieSplitISplit = st.split("=", 2);

      // Removes leading or trailing whitespace
      const first = cookieSplitISplit[0]!.replace(/^\s+|\s+$/g, "");
      const second = cookieSplitISplit[1]!;

      if (first === cookieName) {
          return window.unescape(second);
      }
  }

  return void 0;
};

interface DigitalData {
  page: Page;
}

type DigitalDataCallback = (digitalData: DigitalData) => void;

interface DigitalDataContainer {
  callbacks: DigitalDataCallback[];
  digitalData: DigitalData | undefined;
  registerCallback: (digitalDataCallback: DigitalDataCallback) => void;
  setDigitalData: (digitalData: DigitalData) => void;
}

const digitalDataContainer: DigitalDataContainer = {
  callbacks: [],
  digitalData: void 0,
  registerCallback: function (digitalDataCallback) {
    if (isUndefined(this.digitalData)) {
      this.callbacks.push(digitalDataCallback);
    } else {
      digitalDataCallback(this.digitalData);
    }
  },
  setDigitalData: function (digitalData: DigitalData) {
    this.digitalData = digitalData;

    // https://experienceleague.adobe.com/docs/analytics/implementation/prepare/data-layer.html
    window["digitalData"] = digitalData;

    for (const digitalDataCallback of this.callbacks) {
      try {
        digitalDataCallback(digitalData);
      } catch (er) {
        dnbComLog(LogSeverity.ERROR, er);
      }
    }
  },
};

const getWindowDigitalData = (): DigitalData | undefined => {
 try{
  const localDigitalData = digitalDataContainer.digitalData;
  return localDigitalData;
 } catch {
    dnbComLog(LogSeverity.ERROR, "localDigitalData is undefined")
 }
 
};

const getIsUk = (): boolean => {
  const contentId = getWindowDigitalData()?.page.pageInfo.contentID;

  return isNotUndefined(contentId) && contentId.startsWith("/content/dnb-uk/");
};

const getIsIe = (): boolean => {
  const contentId = getWindowDigitalData()?.page.pageInfo.contentID;

  return isNotUndefined(contentId) && contentId.startsWith("/content/dnb-ie/");
};

const createCookieWithTrustArcCheck = (cookieName: string, value: string, expires: string, retryCounter: number): void => {
  const MAX_RETRY_COUNT = 5;
  const TIMEOUT_IN_MILLIS = 250;
  const privacyManagerAPI = window["PrivacyManagerAPI"];

  if (isNotUndefinedOrNull(privacyManagerAPI)) {
      if ((trustArcGroupIsActive(TrustArcGroupId.trustArcGroupOne) && window.Object.prototype.hasOwnProperty.call(strictlyNecessaryCookies, cookieName))
          || (trustArcGroupIsActive(TrustArcGroupId.trustArcGroupTwo) && window.Object.prototype.hasOwnProperty.call(functionalCookies, cookieName))
          || (trustArcGroupIsActive(TrustArcGroupId.trustArcGroupThree) && window.Object.prototype.hasOwnProperty.call(marketingCookies, cookieName))
      ) {
          window.document.cookie = `${cookieName}=${value}${expires}; path=/`;
      }
  } else if (retryCounter < MAX_RETRY_COUNT) {
      window.setTimeout(() => createCookieWithTrustArcCheck(cookieName, value, expires, retryCounter + 1), TIMEOUT_IN_MILLIS);
  }
};

/**
 * Create a cookie
 *
 * @param cookieName -
 * @param value -
 * @param days - If negative, 0, null, or undefined, the cookie is a session cookie (see https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Set-Cookie#attributes)
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const createCookie = (cookieName: string, value: any, days: number | null | undefined): void => {
  let expires: string;

  if (typeof days === "number" && days > 0) {
      const date = new window.Date();
      date.setTime(date.getTime() + window.Math.round(days * 24 * 60 * 60 * 1000));

      expires = `; expires=${date.toUTCString()}`;
  } else {
      expires = "";
  }

  createCookieWithTrustArcCheck(cookieName, String(value), expires, 0);
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const readCookie = (cookieName: any): string | undefined => dnbGetCookie(cookieName);

const setResourceCookie = (): void => {
    const resourceAccessCookie = dnbGetCookie(resourceAccessCookieName);

    if (isUndefined(resourceAccessCookie) || resourceAccessCookie.length === 0 || resourceAccessCookie === "null") {
        createCookie(resourceAccessCookieName, window.Date.now(), 30);
    }
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const dnbSetCookie = (cookieName: any, value: string, days: number | null | undefined): void => createCookie(cookieName, value, days);

const dnbScroll = (selector: string, speed: number | null | undefined): void => {
  // Z jQuery always returns in px, never em, etc.
  const bodyMarginTop = window.Number($("body").css("margin-top").replace("px", ""));

  const $selector = $(selector);

  const selectorOffset = $selector.offset();

  if (isUndefined(selectorOffset)) {
      dnbComLog(LogSeverity.ERROR, "selectorOffset is undefined");
  } else {
      const scrollTop = window.Math.floor(selectorOffset.top) - bodyMarginTop;

      // 500 is the default speed in milliseconds
      const speedToUse = typeof speed === "number" ? speed : 500;

      $("html, body").animate(
          {
              "scrollTop": scrollTop,
          },
          speedToUse
      );
  }
};

const decodeHtml = (html: string): string => {
  const htmlReplaced = html.replace(/&amp;amp;/g, "&");

  const htmlTextAreaElement = window.document.createElement("textarea");
  htmlTextAreaElement.innerHTML = htmlReplaced;

  return htmlTextAreaElement.value;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const throwErrorIfNotString = (input: any): string => {
    if (typeof input !== "string") {
        dnbComLog(LogSeverity.ERROR, `Expected string value, but throwErrorIfNotString was called with value of type "${typeof input}"`);
    }

    return input;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const throwErrorIfNotNumber = (input: any): number => {
    if (typeof input !== "number") {
        dnbComLog(LogSeverity.ERROR, `Expected number value, but throwErrorIfNotString was called with value of type "${typeof input}"`);
    }

    return input;
};

const valToString = (value: string[] | number | string | undefined): string => {
    if (typeof value === "string") {
        return value;
    } else if (isUndefined(value)) {
        dnbComLog(LogSeverity.ERROR, "val method called on jQuery object with no matching elements");
    } else {
        dnbComLog(LogSeverity.ERROR, `val method called on jQuery object returned non-string type "${(typeof value)}"`);
    }
};

const throwErrorIfUndefined = (input: string[] | number | string | undefined): string[] | number | string => {
    if (isUndefined(input)) {
        dnbComLog(LogSeverity.ERROR, "throwErrorIfUndefined was called with value of type undefined");
    }

    return input;
};

// // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const eraseCookie = (cookieName: any): void => createCookie(cookieName, "", -1);

interface ClientContext {
  DUNSNumber: string | undefined;
  ITExpense: string | undefined;
  SICCode: string | undefined;
  annualSales: string | undefined;
  companyAddress: string | undefined;
  companyName: string | undefined;
  companySize: string | undefined;
  companyZip: string | undefined;
  delinquencyRate: string | undefined;
  domesticDUNSNumber: string | undefined;
  employeeCount: string | undefined;
  employeesAtAllLocation: string | undefined;
  employeesAtLocation: string | undefined;
  functionalArea: string | undefined;
  howTheyPay: string | undefined;
  industry: string | undefined;
  jobFunction: string | undefined;
  jobSeniority: string | undefined;
  location: string | undefined;
  marketability: string | undefined;
  seniority: string | undefined;
  ultimateDuns: string | undefined;
  vanityTitle: string | undefined;
  walletSize: string | undefined;
}

interface DigitalDataCompanyInfo {
  companyCountry: any;
  companyName: any;
  isMarketable: any;
  isPublic: any;
}

interface PageInfo {
  contentID: string | undefined;
  contentType: string | undefined;
  eloquaScoringTags: string | undefined;
  event: string | undefined;
  pageName: string | undefined;
  pageTitle: string | undefined;
  pageURL?: string | undefined;
  segment: string | undefined;
}

interface Page {
  CompanyInfo?: DigitalDataCompanyInfo | undefined;
  clientContext: ClientContext;
  pageInfo: PageInfo;
}

const isValidUnitedKingdomOrIrelandPostalCode = (postalCode: string, isIreland: boolean): boolean => {
    const unitedKingdomPostalCodeRegularExpression = /^[a-z]{1,2}\d{1,2}[a-z]? ?\d[a-z]{2}$/i;

    const irelandPostalCodeRegularExpression = /^(a41|a42|a45|a63|a67|a75|a81|a82|a83|a84|a85|a86|a91|a92|a94|a96|a98|c15|d01|d02|d03|d04|d05|d06|d07|d08|d09|d10|d11|d12|d13|d14|d15|d16|d17|d18|d20|d22|d24|d6w|e21|e25|e32|e34|e41|e45|e53|e91|f12|f23|f26|f28|f31|f35|f42|f45|f52|f56|f91|f92|f93|f94|h12|h14|h16|h18|h23|h53|h54|h62|h65|h71|h91|k32|k34|k36|k45|k56|k67|k78|n37|n39|n41|n91|p12|p14|p17|p24|p25|p31|p32|p36|p43|p47|p51|p56|p61|p67|p72|p75|p81|p85|r14|r21|r32|r35|r42|r45|r51|r56|r93|r95|t12|t23|t34|t45|t56|v14|v15|v23|v31|v35|v42|v92|v93|v94|v95|w12|w23|w34|w91|x35|x42|x91|y14|y21|y25|y34|y35)(\s?)([\dac-fhknprtv-y]{4})$/i;

    const regularExpression = isIreland ? irelandPostalCodeRegularExpression : unitedKingdomPostalCodeRegularExpression;

    return regularExpression.test(postalCode);
};

const getParameterByNameOrUndefined = (parameterName: string): string | undefined => {
  const _name = parameterName.replace(/\[/, "\\[").replace(/]/, "\\]");

  const regularExpressionString = `[\\?&]${_name}=([^&#]*)`;

  const regularExpression = new RegExp(regularExpressionString, "i");

  const results = regularExpression.exec(window.location.search);

  return results === null ? void 0 : window.decodeURIComponent(results[1]!.replace(/\+/g, " "));
};

const getParameterByName = (parameterName: string): string => {
  const stringOrUndefined = getParameterByNameOrUndefined(parameterName);

  return isNotUndefined(stringOrUndefined) ? stringOrUndefined : "";
};

const gotoURL = (currentUrl: string): void => {
  const $window = $(window);

  const windowHeightDividedByTwo = $window.height()! / 2;
  const windowWidthDividedByTwo = $window.width()! / 2;

  window.open(currentUrl + window.location.href, "shareWindow", `height=450, width=550, top=${windowHeightDividedByTwo - 275}, left=${windowWidthDividedByTwo - 225}, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0`);
};

const getWindowUnderscoreSatellite = (): any => {
  const windowUnderscoreSatellite: any = window["_satellite"];

  if (
    typeof windowUnderscoreSatellite !== "object" ||
    windowUnderscoreSatellite === null
  ) {
    dnbComLog(LogSeverity.ERROR, "windowUnderscoreSatellite is not an object");
  }

  return windowUnderscoreSatellite;
};

// Click tracking - Adobe Analytics
const track_event = (eventName: string): void => {
  window["linkTrackingName"] = eventName;

  try {
    getWindowUnderscoreSatellite().track("linkTrackingEvent");
  } catch (er) {
    dnbComLog(LogSeverity.ERROR, er);
  }
};

// TODO
// Moved from CompanyNewFinancials.ts
// Responsive resize functionality
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const resize_financials_chart = (data: any, options: any, chart: any): void => {
    // Add a ready event listener for each redraw
    // Google.visualization.events.addListener(chart, 'ready', init);

    const containerWidth = $(".company_new_financials .tabbed-nav-is-content").width();
    const aspectRatio = options.height / options.width;

    chart.draw(data, {...options, "height": containerWidth! * aspectRatio, "width": containerWidth});
};

const getWindowBizible = (): any => {
    const biziblePropertyName = "Bizible";

    const oldWindowBizible = window[biziblePropertyName];

    let newWindowBizible;

    if (isUndefinedOrNull(oldWindowBizible)) {
        newWindowBizible = {
            "Push": function (o: any, p: any) {
                this._queue.push({"data": p, "type": o});
            },
            "_queue": [],
        };

        window[biziblePropertyName] = newWindowBizible;
    } else {
        newWindowBizible = oldWindowBizible;
    }

    return newWindowBizible;
};

interface ContactCta {
    exists: () => boolean;
    togglePanel: () => void;
}

const globalContactCta: ContactCta = {
    "exists": () => false,
    "togglePanel": () => {
        dnbComLog(LogSeverity.WARN, "togglePanel has not been initialized yet");
    },
};

let mediaQueryList: MediaQueryList | undefined;
let viewportIsMobile: boolean | undefined;

const checkViewportIsMobile = (me: MediaQueryList | MediaQueryListEvent) => {
  const matches = me.matches;

  viewportIsMobile = matches;

  $("html").toggleClass("mobile", matches);

  return matches;
};

const getViewportIsMobile = (): boolean => {
  if (isUndefined(viewportIsMobile)) {
    mediaQueryList = window.matchMedia("screen and (max-width: 991px)");

    mediaQueryList.addEventListener("change", (me) =>
      checkViewportIsMobile(me)
    );

    return checkViewportIsMobile(mediaQueryList);
  }

  return viewportIsMobile;
};

const addViewportIsMobileListener = (
  callback: (isMobile: boolean) => void
): void => {
  getViewportIsMobile();

  mediaQueryList!.addEventListener("change", (me) => callback(me.matches));

  callback(viewportIsMobile!);
};

const setPropertyOnObject = (baseObject: {[string: string]: any}, propertyName: string): any => {
    const existingProperty = baseObject[propertyName];

    const unset = isUndefinedOrNull(existingProperty);

    const newProperty = unset ? {} : existingProperty;

    if (unset) {
        baseObject[propertyName] = newProperty;
    }

    return newProperty;
};

/**
 * @param telephoneNumberToProcess -
 * @returns Telephone number without country code, or null if the country code could not be removed
 */
const removeCountryCodeFromTelephoneNumber = (telephoneNumberToProcess: string): string | undefined => {
    let cleanedNumber: string | undefined;

    if (telephoneNumberToProcess.includes("+")) {
        if (telephoneNumberToProcess.includes("+1")) {
            // US or Canada number
            cleanedNumber = telephoneNumberToProcess.slice(2);
        } else if (telephoneNumberToProcess.includes("+44")) {
            // UK number
            cleanedNumber = telephoneNumberToProcess.slice(3);
        } else {
            cleanedNumber = void 0;
        }
    } else {
        cleanedNumber = telephoneNumberToProcess;
    }

    return cleanedNumber;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const masterPhoneOverride = (countryCode: any, newTelephoneNumber: string): void => {
    const telephoneNumber = newTelephoneNumber.replace(/[\s()-]/g, "");
    const numberLink = `${"tel:" + "+"}${window.String(countryCode)}${telephoneNumber}`;

    // Fragments of the new number
    const firstThreeDigitsNew = telephoneNumber.slice(0, 3);
    const secondThreeDigitsNew = telephoneNumber.slice(3, 6);
    const lastFourDigitsNew = telephoneNumber.slice(6);

    // Lookup links which contain phone number
    $('a[href*="tel:"]').each((_, ht) => {
        const $this = $(ht);

        const oldTelephoneNumber = throwErrorIfNotString($this.attr("href")).slice(4);
        const telephoneNumberWithoutCountryCodeOrUndefined = removeCountryCodeFromTelephoneNumber(oldTelephoneNumber);

        // If we can override
        if (isNotUndefined(telephoneNumberWithoutCountryCodeOrUndefined) && telephoneNumberWithoutCountryCodeOrUndefined.length > 0) {
            let firstThreeDigitsOld;
            let secondThreeDigitsOld;
            let lastFourDigitsOld;

            if (throwErrorIfNotString($this.attr("href")).length === 18) {
                // Fragments of old number
                firstThreeDigitsOld = telephoneNumberWithoutCountryCodeOrUndefined.slice(1, 4);
                secondThreeDigitsOld = telephoneNumberWithoutCountryCodeOrUndefined.slice(6, 9);
                lastFourDigitsOld = telephoneNumberWithoutCountryCodeOrUndefined.slice(10);
            } else {
                // Fragments of old number
                firstThreeDigitsOld = telephoneNumberWithoutCountryCodeOrUndefined.slice(0, 3);
                secondThreeDigitsOld = telephoneNumberWithoutCountryCodeOrUndefined.slice(3, 6);
                lastFourDigitsOld = telephoneNumberWithoutCountryCodeOrUndefined.slice(6);
            }

            $this.attr("href", numberLink);

            const newHtml = $this.html().replace(firstThreeDigitsOld, firstThreeDigitsNew).replace(secondThreeDigitsOld, secondThreeDigitsNew).replace(lastFourDigitsOld, lastFourDigitsNew);

            $this.html(newHtml);
        }
    });
};

const applyHoverZoomEffect = (selector: string, propertiesDisableHover: string | null | undefined): void => {
    $(() => {
        // On hover zoom effect for images
        const $selector = $(selector);
        const disableHover = propertiesDisableHover === "true";

        if (disableHover) {
            // Disable hover
            $selector.off("mouseenter");
        } else {
            // Enable hover
            $selector.on("mouseenter", "img", (eventObject) => {
                $(eventObject.currentTarget).css({
                    "transform": "scale(1.1)",
                    "transition": "all 0.2s ease 0s",
                });
            });

            $selector.on("mouseleave", "img", (eventObject) => {
                $(eventObject.currentTarget).css({
                    "transform": "scale(1.0)",
                    "transition": "all 0.2s ease 0s",
                });
            });
        }
    });
};

const validateEmail = ($emailInput: JQuery): string | undefined => {
    let error: string | undefined;

    if ($emailInput.length > 0) {
        const emailInputValue = $emailInput.val();

        const emailInputValueString = valToString(emailInputValue);

        if (emailInputValueString.replace(/.*@/, "").length > 0) {
            error = emailInputValueString.match(emailAddressRegularExpression) === null ? "invalid-email" : void 0;
        } else {
            error = "enter-email";
        }

        return error;
    } else {
        dnbComLog(LogSeverity.ERROR, new Error("Unable to perform email address validation, no element matched selector"));

        return void 0;
    }
};

const getLeadformErrorMessages = (): {[string: string]: Record<string, string>} => ({
    "en": {
        "enter-address": "Please enter Street Address",
        "enter-company": "Please enter Company",
        "enter-email": "Please enter Email",
        "enter-first-name": "Please enter First Name",
        "enter-last-name": "Please enter Last Name",
        "enter-phone": "Please enter Phone",
        "enter-submitter-email": "Please enter Submitter Email",
        "enter-submitter-name": "Please enter Submitter Name",
        "enter-submitter-phone": "Please enter Submitter Phone",
        "enter-zip": "Please enter Postal Code",
        "invalid-duns-9digit": "Omit dashes and include leading zeros. Must be in 9 digit format.",
        "invalid-email": "The Email that you entered appears to be invalid",
        "invalid-phone": "Please enter a valid Phone",
        "invalid-zip": "The Postal Code that you entered appears to be invalid",
        "invalid-zip-5digit": "The Postal Code that you entered appears to be invalid, it must be 5 digits",
        "make-selection": "Please make a selection",
        "please-enter": "Please enter ",
        "select-country": "Please select Country",
        "select-department": "Please select Department",
        "select-sellto": "Please select a company sell to option",
        "select-title": "Please select Title",
        "specify-crm": "Please specify a CRM",
        "specify-crm-type": "Please specify a CRM Type",
    },
    "fr": {
        "enter-address": "Veuillez entrer l'adresse municipale de la société",
        "enter-company": "Veuillez entrez la société",
        "enter-email": "Veuillez entrez le courriel",
        "enter-first-name": "Veuillez entrez le prénom",
        "enter-last-name": "Veuillez entrez le nom",
        "enter-phone": "Veuillez entrez le nº de téléphone",
        "enter-submitter-email": "S'il vous plaît entrez Déposant Email",
        "enter-submitter-name": "S'il vous plaît entrez Déposant Nom",
        "enter-submitter-phone": "S'il vous plaît entrez Déposant Téléphone",
        "enter-zip": "Veuillez entrez le code postal",
        "invalid-duns-9digit": "Omettez les tirets et incluez les zéros au début. Doit être au format à 9 chiffres.",
        "invalid-email": "L'e-mail que vous avez saisi ne semble pas valide",
        "invalid-phone": "S'il vous plaît entrez un téléphone valide",
        "invalid-zip": "Le code postal que vous avez saisi ne semble pas valide",
        "invalid-zip-5digit": "Le code postal que vous avez saisi ne semble pas valide, il doit être de 5 chiffres",
        "make-selection": "S'il vous plaît faites une sélection",
        "please-enter": "Entrez s'il vous plaît ",
        "select-country": "S'il vous plaît sélectionnez Pays",
        "select-department": "S'il vous plaît sélectionnez département",
        "select-sellto": "S'il vous plaît choisissez une entreprise de vente à l'option",
        "select-title": "Veuillez sélectionnez le titre",
        "specify-crm": "S'il vous plaît spécifiez un CRM",
        "specify-crm-type": "S'il vous plaît spécifiez un type CRM",
    },
});

const stringOrEmptyString = (input: string | null | undefined): string => (typeof input === "string" ? input : "");

// /**
//  * @param messageKey -
//  * @param language - Two character language code ("en" or "fr")
//  */
const getLocalizedMessage = (messageKey: string, language: string): string => {
    const leadformErrorMessages = getLeadformErrorMessages();

    let languageObject;

    // French override
    if (language === "fr") {
        languageObject = leadformErrorMessages["fr"]!;
    } else {
        // English default
        languageObject = leadformErrorMessages["en"]!;
    }

    return stringOrEmptyString(languageObject[messageKey]);
};

const extractHostname = (url: string): string => {
  const urlSplit = url.split("/");

  const urlSplitFirstElement = urlSplit[0]!;

  return url.includes("://")
      ? `${urlSplitFirstElement}//${urlSplit[1]!}${urlSplit[2]!}`
      : urlSplitFirstElement;
};

/**
 * Checks to see if entered string is valid email address
 *
 * @param emailAddress - email address
 * @returns returns whether email address is valid or not
 */
const isValidEmailAddress = (emailAddress: string): boolean => {
  // eslint-disable-next-line no-control-regex
  const emailAddressRegularExpressionTwo = /^([\w!#$%&'*+/=?^`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF-]+(\.[\w!#$%&'*+/=?^`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF-]+)*|"((([\t ]*\r\n)?[\t ]+)?([\u0001-\u0008\u000B\u000C\u000E-\u001F!\u0023-\u005B\u005D-\u007F\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\u0001-\u0009\u000B-\u007F\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([\t ]*\r\n)?[\t ]+)?")@(([\da-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[\da-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][\w.~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF-]*[\da-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][\w.~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF-]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;

  return emailAddressRegularExpressionTwo.test(emailAddress);
};

/**
 * Only returns a string if the cookie value is non-empty
 *
 * @param cookieName -
 */
const getNonEmptyCookieValueOrUndefined = (cookieName: string): string | undefined => {
  const documentCookieSplit = window.document.cookie.split(";");

  for (const st of documentCookieSplit) {
      const currentCookieNameAndValue = st.split("=", 2);

      const currentCookieNameWithoutLeadingOrTrailingWhitespace = currentCookieNameAndValue[0]!.replace(/^\s+|\s+$/g, "");

      if (currentCookieNameWithoutLeadingOrTrailingWhitespace === cookieName) {
          const currentCookieValue = currentCookieNameAndValue[1]!;

          if (currentCookieValue.length > 0) {
              return window.unescape(currentCookieValue);
          }
      }
  }

  return void 0;
};

const setHiveNine = (): void => {
  const h9mc = getParameterByNameOrUndefined(h9mcCookieName);

  if (isNotUndefined(h9mc) && h9mc.length > 0) {
      createCookie(h9mcCookieName, h9mc, void 0);
  }
};

// Updated visitorFrom function
const getVisitorFrom = (): string => {
  const serv = getParameterByNameOrUndefined("serv");

  const visitorFrom = isNotUndefined(serv) ? serv : getParameterByNameOrUndefined("Serv");
  const visitorFromCampaignPage = "${chatVisitorFromId}";

  return isNotUndefined(visitorFrom) ? visitorFrom : visitorFromCampaignPage;
};

const getChatCampaignID = (): string => {
  const campaignQuery = getParameterByNameOrUndefined("ch");
  const chatCampaignPage = "${chatCampaignId}";

  return isNotUndefined(campaignQuery) ? campaignQuery : chatCampaignPage;
};

const getCreativeID = (): string => window.document.URL.split("?")[0]!;

const getVisitorID = (): string => {
    const hidCookieValue = dnbGetCookie(hidCookieName);

    if (isNotUndefined(hidCookieValue) && hidCookieValue.length > 0 && hidCookieValue !== "null") {
        return hidCookieValue;
    }

    const today = new window.Date();
    const cookieValue = today.getTime();

    createCookie(hidCookieName, cookieValue, 30);

    return window.String(cookieValue);
};

const getGCLID = (): void => {
  const gclid = getParameterByNameOrUndefined(gclidCookieName);

  if (isNotUndefined(gclid) && gclid !== "null") {
      const gclsrc = getParameterByNameOrUndefined("gclsrc");

      if (isUndefined(gclsrc) || gclsrc.length === 0 || gclsrc.includes("ds")) {
          createCookie(gclidCookieName, gclid, 90);
      }
  }
};

interface SiteAndLangCodeObject {
    countryCode: string | null | undefined;
    languageCode: string;
    siteNode: string;
}

const getCountryCode = (siteNode: string): string | null | undefined => {
    let countryCode;

    if (isNotUndefined(siteNode)) {
        const charArr = siteNode.split("-");

        // Will return cc excepts for us or mod
        if (charArr.length > 0 && !(charArr[1] === "us" || charArr[1] === "mod")) {
            countryCode = charArr[1];
        }
    }

    return countryCode;
};

const getCountryProperties = (currentPageAbsoluteParentTwoPagePath: string): SiteAndLangCodeObject => {
    const currentPageAbsoluteParentTwoPagePathSplit = currentPageAbsoluteParentTwoPagePath.split("/");
    const siteNode = currentPageAbsoluteParentTwoPagePathSplit.slice(-2)[0]!;
    const languageCode = currentPageAbsoluteParentTwoPagePathSplit.slice(-1)[0]!;
    const countryCode = getCountryCode(siteNode);

    return {
        "countryCode": countryCode,
        "languageCode": languageCode,
        "siteNode": siteNode
    };
};

const runOnlyOnce: (functionToCustomize: () => void) => () => void = (functionToCustomize: () => void) => {
    let hasNotRun = true;

    return () => {
        if (hasNotRun) {
            hasNotRun = false;

            functionToCustomize();
        } else {
            dnbComLog(LogSeverity.INFO, "Ignoring subsequent execution of code");
        }
    };
};

interface ApplyHoverZoomEffectWrapperParameter {
    "applyHoverZoomEffectDisablehover": string | null | undefined;
    "applyHoverZoomEffectIdentifier": string | null | undefined;
}

interface ApplyHoverZoomEffectWrapperParameterObject {
    "applyHoverZoomEffectWrapperParameter": ApplyHoverZoomEffectWrapperParameter;
}

const applyHoverZoomEffectWrapper = (applyHoverZoomEffectWrapperParameter: ApplyHoverZoomEffectWrapperParameter): void => {
    const identifier = applyHoverZoomEffectWrapperParameter.applyHoverZoomEffectIdentifier;

    if (typeof identifier === "string" && identifier.length > 0) {
        applyHoverZoomEffect(`.${identifier}`, applyHoverZoomEffectWrapperParameter.applyHoverZoomEffectDisablehover);
    }
};

const checkString = (value: string | null | undefined): value is string => isNotUndefined(value) && value !== null && value.length > 0;

const postForm =
    (
        path: string,
        parameters: Record<string, string | undefined>,
        method: "get" | "post" = "post"
    ): void => {
        const form = window.document.createElement("form");

        form.setAttribute("method", method);
        form.setAttribute("action", path);

        for (const key in parameters) {
            if (window.Object.prototype.hasOwnProperty.call(parameters, key)) {
                const value = parameters[key];

                let valueToUse: string;

                if (isUndefined(value)) {
                    dnbComLog(LogSeverity.WARN, `value is undefined (key: ${key})`);

                    valueToUse = window.String(value);
                } else {
                    valueToUse = value;
                }

                const hiddenField = window.document.createElement("input");
                hiddenField.setAttribute("type", "hidden");
                hiddenField.setAttribute("name", key);
                hiddenField.setAttribute("value", valueToUse);

                form.append(hiddenField);
            }
        }

        window.document.body.append(form);

        form.submit();
    };

// Non-WCAG A/WCAG AA
const nonAaAxeViolationsIdSet = new window.Set([
    "accesskeys",
    "aria-allowed-role",
    "aria-dialog-name",
    "aria-text",
    "aria-treeitem-name",
    "color-contrast-enhanced",
    "css-orientation-lock",
    "empty-heading",
    "empty-table-header",
    "focus-order-semantics",
    "frame-tested",
    "heading-order",
    "hidden-content",
    "identical-links-same-purpose",
    "image-redundant-alt",
    "label-content-name-mismatch",
    "label-title-only",
    "landmark-banner-is-top-level",
    "landmark-complementary-is-top-level",
    "landmark-contentinfo-is-top-level",
    "landmark-main-is-top-level",
    "landmark-no-duplicate-banner",
    "landmark-no-duplicate-contentinfo",
    "landmark-no-duplicate-main",
    "landmark-one-main",
    "landmark-unique",
    "meta-refresh-no-exceptions",
    "meta-viewport-large",
    "p-as-heading",
    "page-has-heading-one",
    "presentation-role-conflict",
    "region",
    "scope-attr-valid",
    "skip-link",
    "tabindex",
    "table-duplicate-name",
    "table-fake-caption",
    "td-has-header"
]);

const getSiteNode = (currentPageAbsoluteParentTwoPagePath: string): string => {
    const currentPageAbsoluteParentTwoPagePathSplit = currentPageAbsoluteParentTwoPagePath.split("/");
    return currentPageAbsoluteParentTwoPagePathSplit.slice(-2)[0]!;
};

// https://github.com/jquery/jquery-migrate/blob/main/warnings.md#load-after-event-jqmigrate-jquerywindowonload-called-after-load-event-occurred
const windowOnLoadOrImmediate = (
  $window: JQuery<Window>,
  handler: () => void
): JQuery<Window> => {
  if (window.document.readyState === "complete") {
    handler();
  } else {
    $window.on("load", handler);
  }

  return $window;
};

const typedGet =
    <E extends ExportedGet<R, S>,
        R extends ExportedGetRequest<E>,
        S extends ExportedGetResponse<E>>
    (url: string, params: R): Promise<AxiosResponse<S>> =>
        axios.get<S>(
            url,
            {
                "params": params
            }) 
            .catch((error: AxiosError) => {
                dnbComLog(LogSeverity.ERROR, `Error in typedGet for URL ${url}: ${error?.message}`);
                throw error; // Re-throw the error to propagate it
            });

const typedPost =
    <E extends ExportedPost<R, S>,
        R extends ExportedPostRequest<E>,
        S extends ExportedPostResponse<E>>
    (url: string, data: R): Promise<AxiosResponse<S>> =>
        axios.post<never, AxiosResponse<S>, R>(
            url,
            data)  
            .catch((error: AxiosError) => {
                dnbComLog(LogSeverity.ERROR, `Error in typedPost for URL ${url}: ${error?.message}`);
                throw error; // Re-throw the error to propagate it
            });

const setCompanyInfoCookie = (
  companyInformationForCookie: CompanyInformationForCookie
): void => {
  const companyInformationForCookieJson = window.JSON.stringify(
    companyInformationForCookie
  );

  createCookie(companyInfoCookieName, companyInformationForCookieJson, void 0);
};

const getCompanyInfoCookie = (): CompanyInformationForCookie | undefined => {
  const companyInformationForCookieJson = dnbGetCookie(companyInfoCookieName);

  if (isUndefined(companyInformationForCookieJson)) {
      return void 0;
  }

  if (companyInformationForCookieJson.length === 0) {
      return void 0;
  }

  const companyInformationForCookie: CompanyInformationForCookie = window.JSON.parse(window.decodeURIComponent(companyInformationForCookieJson.toString().replace(/%/g,'~~pct~~')));

  return companyInformationForCookie;
};

const trustArcConsentSource = (): string | undefined => {
try {
  const privacyManagerAPI = getPrivacyManagerAPI();
  let consentDecisionSource: string | undefined;

  if (isNotUndefinedOrNull(privacyManagerAPI)) {
    const getConsentDecision = privacyManagerAPI.callApi("getConsentDecision", window.location.hostname); 

      // Fetch consent source - possible values 1.implied 2.asserted.     
      // const getConsentDecision = {source: "asserted"} 
      consentDecisionSource = getConsentDecision.source;
  }
  return consentDecisionSource;
} catch{}
};


// /**
//  * This function returns value of notice_behavior cookie to determine location and behavior manager based on domain.
//  * When no notice_behavior cookie exists, this returns a blank string.
//  */
const getNoticeBehavior = (): string => {
  let nb: string | undefined = "";
  const regexNoticeBehavior = /\s*notice_behavior\s*=\s*([^;]*)/;
  const result = regexNoticeBehavior.exec(document.cookie);
  if (isNotUndefinedOrNull(result) && result.length > 1) {
    nb = result[1];
  }
  return isNotUndefinedOrNull(nb) ? nb : "";
};

  /**
 * Method to Determine Whether a Specific Tracker is Opted In or Out
 * "getConsent",
 * "domainThatIsAsking.com",
 * "targetVendorDomain.com",
 * "authorizingBodyDomain.com",
 * "defaultbuckettype" - required | functional | advertising,
 */
const getConsentByTrackerType = (type: string): boolean => 
isNotUndefined(getPrivacyManagerAPI())
&& getPrivacyManagerAPI().callApi("getConsent", window.location.hostname, "", "", type).consent === "approved";

// {"source":"asserted","consent":"approved"} 


// /**
//  * Check if behavior manager is EU.
//  */
const isEU = /.*(,|)eu/i.test(getNoticeBehavior());

const showGoogleAds = (): boolean => (isNotUndefinedOrNull(trustArcConsentSource())
    && trustArcConsentSource() === "asserted"
      && getConsentByTrackerType("advertising"));

const formatData = (value) => {
  if (value < 0) {
    return `-$${Math.abs(Math.round(value)).toLocaleString()}`;
  } else {
    return `$${Math.round(value).toLocaleString()}`;
  }
};

const setTabNameInDigitalData = (tabName: string) => {
    if (
        window["digitalData"]["page"]["pageInfo"]["companyProfile"] == undefined
      ) {
        window["digitalData"]["page"]["pageInfo"]["companyProfile"] = {};
      }
      if (
        window["digitalData"]["page"]["pageInfo"]["companyProfile"][
          "financials"
        ] == undefined
      ) {
        window["digitalData"]["page"]["pageInfo"]["companyProfile"][
          "financials"
        ] = [];
        window["digitalData"]["page"]?.["pageInfo"]?.["companyProfile"]?.[
          "financials"
        ].push(tabName);
      } else {
        window["digitalData"]["page"]?.["pageInfo"]?.["companyProfile"]?.[
          "financials"
        ].push(tabName);
      }
}

const parseAdData = (adData: any[] | string) => {
    if (typeof adData === "string") {
      return [window.JSON.parse(adData)];
    } else if (window.Array.isArray(adData)) {
      return adData.map((adObject) => window.JSON.parse(adObject));
    } else {
      return [];
    }
  };

export {
  addViewportIsMobileListener,
      analyticsEvent,
      applyHoverZoomEffect,
      applyHoverZoomEffectWrapper,
      ApplyHoverZoomEffectWrapperParameterObject,
  body,
  canadaIsoCode,
      canadaUnitedStatesPhoneNumberRegularExpression,
      checkString,
      clearVars,
  consolidatedHeaderObject,
      ContactCta,
      createCookie,
      currentTimestamp,
      dataCnCookieName,
      dataEmCookieName,
      dataFnCookieName,
      dataTnCookieName,
      decodeHtml,
  digitalDataContainer,
  dnbComLog,
  dnbGetCookie,
      dnbScroll,
      dnbSetCookie,
      emailAddressRegularExpression,
      eraseCookie,
      evenHeights,
      evenHeightsUnfiltered,
      evenHeightsV2,
      extIcon,
      extractHostname,
      functionalCookies,
      gclidCookieName,
      getChatCampaignID,
      getCompanyInfoCookie,
      getConsentByTrackerType,
      getCountryProperties,
      getCreativeID,
      getGCLID,
  getIsIe,
  getIsUk,
      getLeadformErrorMessages,
      getLocalizedMessage,
      getMarketoFormWrapper,
      getNonEmptyCookieValueOrUndefined,
  getNoticeBehavior,
      getParameterByName,
      getParameterByNameOrUndefined,
  getPrivacyManagerAPI,
      getRuntimeEnvironment,
      getSiteNode,
  getViewportIsMobile,
      getVisitorFrom,
      getVisitorID,
      getWindowBizible,
      getWindowDataLayer,
      getWindowDigitalData,
      getWindowExponea,
      getWindowS,
  getWindowUnderscoreSatellite,
      globalContactCta,
      gotoURL,
      gpcpCookieName,
      h9mcCookieName,
      hidCookieName,
      irelandIsoCode,
  isNotUndefined,
  isNotUndefinedOrNull,
  isUndefined,
      isUndefinedOrNull,
      isValidEmailAddress,
      isValidUnitedKingdomOrIrelandPostalCode,
  languagePreferenceCookieName,
      lazyLoadScriptMarketo,
  LogSeverity,
      marketingCookies,
      masterPhoneOverride,
      nonAaAxeViolationsIdSet,
  overlayClassName,
      postForm,
      readCookie,
      resize_financials_chart,
      resourceAccessCookieName,
      runOnlyOnce,
  setCompanyInfoCookie,
      setHiveNine,
      setPropertyOnObject,
      setResourceCookie,
      setRuntimeEnvironment,
  showGoogleAds,
  sitePreferenceCookieName,
      strictlyNecessaryCookies,
      stringOrEmptyString,
      throwErrorIfNotNumber,
      throwErrorIfNotString,
      throwErrorIfUndefined,
  track_event,
      trackAssociateDunsCompanySearchEvent,
      trackAssociateDunsContinueToCpEvents,
      trackBloomreachCartEvents,
      trackBloomreachConsentEvents,
      trackBloomreachIdentifyEvents,
      trackBloomreachPurchaseEvents,
      trackBloomreachPurchaseItemEvents,
      trackBloomreachViewEvents,
      trackCartEvents,
      trackCartEventsCore,
      trackCompanyProfileGalleryClickEvents,
  trackDataMaskIconClickEvents,
      trackGTMEvents,
      trackGTMSearchSubmitEvents,
  trackNullSearchResults,
      trackPartnerExchangeExitEvents,
      trackPostCardClickEvents,
  trackRefineSearchClickEvents,
      trackSearchEvents,
      trackSearchType,
      trackUTMCodesOnGADFlow,
  trustArcConsentSource,
      TrustArcGroupId,
      trustArcGroupIsActive,
      typedGet,
      typedPost,
      unitedKingdomIsoCode,
      unitedStatesIsoCode,
      validateEmail,
      valToString,
      videoTracking,
      wAddressCookieName,
      wBusPhoneCookieName,
      wCompanyNameCookieName,
      wEmailAddressCookieName,
      wFirstNameCookieName,
  windowOnLoadOrImmediate,
      wLastNameCookieName,
      wTitleCookieName,
      wZipPostalCookieName,
      formatData,
      setTabNameInDigitalData,
      parseAdData
};
